import { PhoneInput } from './phone-input.component';

export * from './phone-input.component';
export default PhoneInput;

PhoneInput.define('der-ui-phone-input');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-phone-input': PhoneInput;
    }
}
